export enum DocumentStatusEnum {
    PENDING_SIGNATURE = 'pending_signature',
    COMPLETED_SIGNATURE = 'completed_signature',
    COMPLETED = 'completed'
}
